export default __webpack_public_path__ + "static/media/2087-01.9cb1762d.jpg";